'use client'

import ParsedHtmlContent from "@/components/etc/renderContent"
import WebSocketClient, { ChatContext } from "@/context/chatContext"
import { NavContext } from "@/context/navContext"
import { chatMessagesType } from "@/type/chat"
import api from "@/util/api"
import { useTranslations } from "next-intl"
import { RefObject, useContext, useEffect, useMemo, useRef, useState } from "react"


export default function ChatLayout() {
    const { messages, Send, del_id } = useContext(ChatContext)
    const [mount, setMount] = useState<boolean>(false)
    const [inputChat, setInputChat] = useState<string>("")

    const [chatMessages, setChatMessages] = useState<chatMessagesType[]>([])
    const scrollRef = useRef<HTMLUListElement>(null)
    const { movePage } = useContext(NavContext)

    const t = useTranslations('Text')

    function sendMessage() {
        const trimMessage = inputChat.trim()
        Send(trimMessage)
        setInputChat('')
    }



    useEffect(() => {
        api(`/api/chat/`)
            .then(res => res.json())
            .then(data => {
                const prevList: any[] = data?.data?.messages_list ?? []

                setChatMessages(prevList.reverse())
            })
    }, [])

    useEffect(() => {
        setMount(true)
    }, [])
    useEffect(() => {
        const newMessages: chatMessagesType[] = [];
        // console.log(messages)
        if (messages) {
            setChatMessages([...chatMessages, messages])
        }
    }, [messages])
    useEffect(() => {
        // console.log(del_id)
        if (del_id && del_id > 0) {
            const newDelMessages = chatMessages.filter(el => el.id != del_id)
            // console.log(newDelMessages)
            setChatMessages(newDelMessages)
        }
    }, [del_id])


    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;
        // console.log(el.scrollHeight)

        // 컨테이너만 아래로 스크롤
        // if(chatMessages)
        // el.scrollTo({ top: el.scrollHeight});
        // el.scrollTop = el.scrollHeight + 1000;


        // }, [chatMessages, scrollRef.current?.scrollHeight])
    }, [scrollRef.current?.scrollHeight])

    // useEffect(() => {
    //     const el = scrollRef.current;
    //     if (!el) return;
    //     setTimeout(() => {
    //         requestAnimationFrame(() => {
    //             el.scrollTop = el.scrollHeight +200;
    //         });

    //     }, 200);
    // }, [chatMessages]);





    return (
        <div className="chat-container">
            <header>{t('실시간 안내사항')}</header>
            <div className="notice-body">
                <ul id="notice-list" className="notice-list" role="log" aria-live="polite" ref={scrollRef}>
                    {
                        chatMessages?.map((message, index) => (
                            <ChatItems key={message.id} message={message} 
                                        lastIndex={index+1 == chatMessages.length ? scrollRef : null}/>
                        ))
                    }
                </ul>
            </div>
            {/* <ul className="chat-layout" ref={scrollRef}>
                {
                    chatMessages?.map((message, index) => {
                        return (
                        <li key={index}>
                            <div>{message.user_name} :</div>
                            <p dangerouslySetInnerHTML={{ __html: message.message }} />
                            <ParsedHtmlContent key={index} html={message.message} />
                        </li>
                        )
                    })
                }
            </ul> */}
            {/* <div className="send-message-input">
                <input type="text" value={inputChat}
                    placeholder="메세지를 입력 하세요"
                    onChange={e => setInputChat(e.currentTarget.value)}
                    onKeyUp={e => { if (e.key == 'Enter') sendMessage() }} />
                <button onClick={e => sendMessage()}>보내기</button>
            </div> */}
        </div>
    )
}

function ChatItems({message, lastIndex=null}: {message: chatMessagesType, lastIndex?: RefObject<HTMLUListElement> | null}) {
    const t = useTranslations('Text');

    useEffect(()=> {
        if(lastIndex !== null){            
            const el = lastIndex.current;
            if (!el) return;
            setTimeout(() => {
                requestAnimationFrame(() => {
                    el.scrollTop = el.scrollHeight +200;
                });

            }, 200);
        }
    }, [lastIndex])
    return (
        <li className="notice-item"
            onClick={() => { if (message.link_url) location.href = message.link_url }}>
            <div className="meta small text-muted">{t('스폰티비')}</div>
            <div className="text">
                <img src={`${message.message}`} alt="공지 이미지" style={{ height: `auto`, boxShadow: `0 1px 3px rgba(0,0,0,0.1)` }} />
                {message.link_url &&
                    <div className={`barogagi`}
                        onClick={() => { if (message.link_url) location.href = message.link_url }}>{t('바로가기')}</div>
                }
            </div>
        </li>
    )
}